import { Box } from '@rbilabs/universal-components';

import { InnerLayout, LayoutContainer } from 'components/layout/styled';
import { primitive } from 'styles/constants/primitives';

export const ProductSelectionsContainer = Box.withConfig({
  width: 'full',
  background: primitive.$white,
});

export const ProductHomeInnerLayout = InnerLayout.withConfig<{ $isFullContainer?: boolean }>(
  ({ $isFullContainer }) => ({
    paddingY: 0,
    marginY: 0,
    ...($isFullContainer && { padding: 0, margin: 0 }),
  })
);

export const ProductHomeLayoutContainer = LayoutContainer.withConfig({
  marginY: 0,
  paddingY: 0,
});

export const ProductInformationSection = Box.withConfig({
  marginY: {
    base: '$4',
    md: '$8',
  },
});
